import(/* webpackMode: "eager", webpackExports: ["SetTranslationData"] */ "/home/liamto-agesco-conseils/www/apps/front/src/i18n/SetTranslationData.tsx");
